var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85229 10.3226C8.85229 9.26172 8.43087 8.24431 7.68072 7.49416C6.93058 6.74402 5.91316 6.32259 4.85229 6.32259M4.85229 6.32259C3.79143 6.32259 2.77401 6.74402 2.02387 7.49416C1.27372 8.24431 0.852295 9.26172 0.852295 10.3226M4.85229 6.32259C6.32505 6.32259 7.51896 5.12868 7.51896 3.65592C7.51896 2.18317 6.32505 0.989258 4.85229 0.989258C3.37954 0.989258 2.18563 2.18317 2.18563 3.65592C2.18563 5.12868 3.37954 6.32259 4.85229 6.32259ZM12.1856 2.98926V6.98926M14.1856 4.98926H10.1856",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.aa55066e8f942936e0e654bed1114d92.svg";
export { ForwardRef as ReactComponent };